import React, { useEffect, useState, useRef } from "react";
import { api, fileUrl } from "../../lib/api";
import { Upload, Trash2, Copy } from "lucide-react";
import { toast } from "sonner";

export default function AdminMedia() {
  const [items, setItems] = useState([]);
  const [up, setUp] = useState(false);
  const fileRef = useRef(null);

  const load = () => api.get("/media").then(r => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const onUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUp(true);
    try {
      for (const f of files) {
        const fd = new FormData(); fd.append("file", f);
        await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      }
      toast.success(`Uploaded ${files.length} file(s)`);
      load();
    } catch (er) { toast.error(er.response?.data?.detail || "Upload failed"); }
    finally { setUp(false); if (fileRef.current) fileRef.current.value = ""; }
  };

  const remove = async (it) => {
    if (!window.confirm(`Delete ${it.original_filename}?`)) return;
    await api.delete(`/media/${it.id}`);
    toast.success("Deleted");
    load();
  };

  const copy = (path) => {
    const url = fileUrl(path);
    navigator.clipboard.writeText(url);
    toast.success("URL copied");
  };

  return (
    <div className="p-5 sm:p-8 lg:p-10" data-testid="admin-media">
      <div className="flex items-center justify-between mb-8">
        <div>
          <p className="label-eyebrow mb-3">Library</p>
          <h1 className="font-serif-display text-3xl sm:text-4xl text-[#1a1a1a]">Media</h1>
        </div>
        <div>
          <input ref={fileRef} type="file" accept="image/*,application/pdf" multiple className="hidden" onChange={onUpload} />
          <button onClick={() => fileRef.current?.click()} disabled={up} className="btn-primary-burgundy disabled:opacity-60" data-testid="upload-media-btn">
            <Upload size={14} /> {up ? "Uploading..." : "Upload"}
          </button>
        </div>
      </div>

      {items.length === 0 ? (
        <div className="text-center py-16 border border-dashed border-neutral-300 text-neutral-500" data-testid="no-media">No media uploaded yet.</div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {items.map((it) => (
            <div key={it.id} className="bg-white border border-neutral-200 group" data-testid={`media-${it.id}`}>
              {it.content_type?.startsWith("image/") ? (
                <img src={fileUrl(it.storage_path)} alt={it.original_filename} className="w-full aspect-square object-cover" />
              ) : (
                <div className="aspect-square bg-neutral-100 flex items-center justify-center text-xs text-neutral-500">{it.original_filename}</div>
              )}
              <div className="p-3">
                <p className="text-xs truncate text-neutral-600 mb-2">{it.original_filename}</p>
                <div className="flex items-center justify-between gap-2">
                  <button onClick={() => copy(it.storage_path)} className="text-xs text-[#6B1F2A] inline-flex items-center gap-1 hover:underline"><Copy size={11} /> Copy URL</button>
                  <button onClick={() => remove(it)} className="text-xs text-neutral-400 hover:text-red-600"><Trash2 size={12} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
